import { BaseService, type PaginationRequest, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Instance } from "@kiddocare-platform/portal-common/core";

export class CoreFlowService extends BaseService {

  public SearchInstance = async (search: PaginationRequest): Promise<ResponseMessage<Array<Instance>>> => {
    try {
      const response = await this.AxiosInstance.post(`/parent/flow/searchInstance`, search);
      return response.data;
    } catch (error: any) {
      this.log.error("SearchInstance", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}